import { render } from "./memberCard.vue?vue&type=template&id=040e5885&scoped=true"
import script from "./memberCard.vue?vue&type=script&lang=js"
export * from "./memberCard.vue?vue&type=script&lang=js"

import "./memberCard.vue?vue&type=style&index=0&id=040e5885&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040e5885"]])

export default __exports__